import { Component, forwardRef, Input, OnInit } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { Field } from '../../models/field'
import { tap, map, concatMap } from 'rxjs/operators'
import { BrowserCompatibilityService } from '../../../../services/browser-compatibility.service'
import { EntityStateService } from '../../services/entity-state.service'

@Component({
  selector: 'jml-lib-fsm-control',
  templateUrl: './fsm-control.component.html',
  styleUrls: ['./fsm-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FsmControlComponent),
      multi: true
    }
  ]
})
export class FsmControlComponent implements OnInit, ControlValueAccessor {
  @Input() field: Field
  @Input() entityType: string
  @Input() entityId: number

  options = []
  onTouched = (state) => {}
  onChange = (state) => {}
  state

  constructor(
    private entityStateService: EntityStateService,
    public browserCompatibilityService: BrowserCompatibilityService
  ) {}

  writeValue(obj: any): void {
    this.state = obj
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  ngOnInit(): void {
    let transitionCount = 0
    let options = []

    this.entityStateService
      .getCurrentState(this.entityType, this.entityId)
      .pipe(
        map((stateMachine) => stateMachine.possibleTransitions),
        tap((transitions) => (transitionCount = transitions.length)),
        concatMap((transitions) => transitions),
        map((transition) => {
          return { label: transition.repr, value: transition }
        })
      )
      .subscribe((transition) => {
        options.push(transition)
        if (options.length == transitionCount) {
          this.options = options
        }
      })
  }

  onTransitionSelected(entry) {
    this.state['transitionId'] = entry.value.id
    this.onTouched(this.state)
    this.onChange(this.state)
  }

  nullField() {
    this.onTouched(undefined)
    this.onChange(undefined)
  }
}
